import React, { Component } from 'react';

class PasswordStrength extends Component {
  render() {
    let passwordStrength = null;
    if (this.props.password !== "" && this.props.password !== null) {
      let strongRegex = new RegExp("^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&*])(?=.{8,})");
      let medRegex = new RegExp("^(((?=.*[a-z])(?=.*[A-Z]))|((?=.*[a-z])(?=.*[0-9]))|((?=.*[A-Z])(?=.*[0-9])))(?=.{6,})");

      if (strongRegex.test(this.props.password)) passwordStrength = <p>Password strength: <b><span style={{"color":"red", "display":"inline-block"}}> Weak</span></b></p>;
      else if (medRegex.test(this.props.password)) passwordStrength = <p>Password strength: <b><span style={{"color":"#CCCC00", "display":"inline-block"}}> Medium</span></b></p>;
      else passwordStrength = <p>Password strength: <b><span style={{"color":"red", "display":"inline-block"}}> Weak</span></b></p>;
    }

    return (
      <div className="form-group">
        <label className="col-md-4 control-label"></label>
        <div className="col-md-8">
        {
          /*
          <p><i>{this.props.password !== "" ? `Password must be at least 8 characters long` : ""}</i></p>{passwordStrength}
          */
        }
        {passwordStrength}
        </div>
      </div>
    )
  }
}

export default PasswordStrength;


// WEBPACK FOOTER //
// ./src/Components/Form/PasswordStrength.js